//@ts-ignore
import useResizeAware from "react-resize-aware";

import CardStatusIcon from "@Components/game/cards/card-status-icon";
import {
  PlaylistCardButtonBase,
  PlaylistCardGlossWrapper,
  PlaylistCardImage,
  PlaylistDescriptionStack,
} from "@Components/game/playlists/common/cards/styled-components";
import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import { Events } from "@Context/common/general/context";
import PlaylistStatusV2 from "@Enums/PlaylistStatusV2";
import { faCheck, faClose } from "@fortawesome/pro-solid-svg-icons";
import { Box, Typography, useTheme } from "@mui/material";

export interface IPlaylistCardBase {
  size?: "small" | "medium";
}

interface IPlaylistCard extends IPlaylistCardBase {
  playlist: any;
  disabled?: boolean;
  fullWidth?: boolean;
}

const PlaylistCard = ({ playlist, size = "medium", fullWidth = false }: IPlaylistCard) => {
  const theme = useTheme();
  const [resizeListener, sizes] = useResizeAware();

  const { id, image_url, name, description, status } = playlist;

  const width = size === "small" ? 318 : 432;
  const height = size === "small" ? 180 : 244;
  const isCompleted = playlist?.status === PlaylistStatusV2.COMPLETED;
  const isFailed = playlist?.status === PlaylistStatusV2.FAILED;

  const handleClick = () => {
    Events.app.navigate.emit({ path: `/playlists/playlist/${playlist.id}` });
  };

  return (
    <HapticsButtonWrapper>
      <PlaylistCardButtonBase id={id} onClick={handleClick}>
        {resizeListener}
        <Box sx={{ cornerShape: "squircle", borderRadius: "40px", height, width, position: "relative", overflow: "hidden" }}>
          <PlaylistCardGlossWrapper id="wrapper" height={height} width={width}>
            <PlaylistCardImage id="backgroundImage" imageUrl={image_url} />
          </PlaylistCardGlossWrapper>

          {(isCompleted || isFailed) && (
            <CardStatusIcon icon={isCompleted ? faCheck : faClose} color={theme.palette[isCompleted ? "dsSuccess" : "dsDestructive"].v300} />
          )}
        </Box>

        <PlaylistDescriptionStack>
          <Typography variant="text2xl500" color={theme.palette.dsBase.v200} noWrap>
            {name}
          </Typography>
          <Typography
            variant="text1xl500"
            color={theme.palette.dsNeutral.v300}
            noWrap
            sx={{
              width: "100%",
              maxWidth: "100%",
            }}
          >
            {description}
          </Typography>
        </PlaylistDescriptionStack>
      </PlaylistCardButtonBase>
    </HapticsButtonWrapper>
  );
};

export default PlaylistCard;
